import { Box, Text } from "@chakra-ui/react";
import React from "react";
import AppColors from "../../../../constants/AppColors";

const CustomMenu = React.forwardRef((props, ref) => {
    return <Box
        p={3}
        position={'absolute'}
        top={7} right={7}
        borderRadius='lg'
        shadow={'md'}
        color={AppColors.secondary}
        width={100}
        bg='white'
        zIndex={1000}
        ref={ref}
    >
        <Box>
            {!props.comment.parent && props.comment.audit_sheet_rows?.length > 0 && (
                <Text mb={2} fontSize={'xs'} cursor={'pointer'} onClick={() => props.onReplyClick()}>
                    Reply
                </Text>
            )}
            <Text fontSize={'xs'} cursor={'pointer'} onClick={() => props.onEditClick()}>
                Edit
            </Text>
            <Text mt={2} fontSize={'xs'} cursor={'pointer'} onClick={() => props.onDeleteClick()}>
                Delete
            </Text>
        </Box>
    </Box>
})

export default CustomMenu
